import { useBootstrapData } from './bootstrap-data.hook';
import type { ICockpitBootstrapData } from '@condo/domain';

const selectDictionaries = (bootstrap: ICockpitBootstrapData) => bootstrap.dictionaries;

export function useDictionaries() {
    const { data, isLoading, error } = useBootstrapData(selectDictionaries);

    return {
        dictionaries: data,
        stateMachines: data?.stateMachines,
        /**
         * The calculation config, keyed by `ConfigSection`. This is the source
         * Cockpit reads — `useRootCalculationConfig()` and every
         * `bootstrapData.dictionaries.rootConfig[...]` site go through the
         * dictionaries payload, **not** `fetchActiveRootConfig()`.
         */
        rootConfig: data?.rootConfig,
        isLoading,
        error,
    };
}
